import React from 'react';
import { GetServerSideProps } from 'next';
import Head from 'next/head';

import { HtmlRenderer, styled } from '@teko/ui';
import { getPostsBySlug } from 'services';
import { LandingPage } from 'components/desktop/pages/Landing';
import { logger } from '@teko/log';
import { useTenantConfig } from 'hooks';

const StyledHtmlRenderer = styled(HtmlRenderer)`
  .elementor-section-wrap {
    > .elementor-element:first-child {
      margin-top: 0;
    }
  }
`;

export interface PostProps {
  post?: {
    id: number;
    title: {
      rendered: string;
    };
    content: {
      rendered: string;
    };
  };
}
const Post: React.FunctionComponent<PostProps> = ({ post }: PostProps) => {
  const { baseDomain, canonicalDomain } = useTenantConfig();
  if (!post) {
    // if there is no post in wordpress
    // render it as the default landing flow
    return <LandingPage />;
  }

  return (
    <>
      <Head>
        <title>{post.title.rendered}</title>
        <link
          rel="stylesheet"
          href="https://legacy.phongvu.vn/landing/wp-content/plugins/elementor/assets/css/frontend.min.css?ver=2.7.5"
          type="text/css"
          media="all"
        />
        <link
          rel="stylesheet"
          href={`https://legacy.phongvu.vn/landing/wp-content/uploads/elementor/css/post-${post.id}.css`}
          type="text/css"
          media="all"
        />
        {/* canonical */}
        <link
          rel="canonical"
          href={`${canonicalDomain || baseDomain}/landing/${post.id}`}
        />
      </Head>
      <StyledHtmlRenderer content={post.content.rendered} />
    </>
  );
};

export const getLandingServerSideProps: GetServerSideProps = async (
  context,
) => {
  let slug = (context.query.id || '').toString();
  if (slug.endsWith('.html')) {
    slug = slug.substring(0, slug.length - 5);
  }

  try {
    const posts = await getPostsBySlug(slug);

    return {
      props: {
        post: (posts && posts[0]) || null,
      },
    };
  } catch (e) {
    logger.error(e);
    return {
      props: {
        post: null,
      },
    };
  }
};

export const getServerSideProps = getLandingServerSideProps;

export default Post;
